module.exports = __webpack_public_path__ + "media/site/images/logo-white-91125540370373bf297a4294586e7f7e.png";